<template>
  <button
    type="button"
    class="ram-theme-toggle"
    :aria-label="mode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'"
    @click="toggle"
  >
    <Transition name="ram-theme-toggle__swap" mode="out-in">
      <svg
        v-if="mode === 'light'"
        key="sun"
        class="ram-theme-toggle__icon"
        viewBox="0 0 24 24"
        width="18"
        height="18"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
      </svg>
      <svg
        v-else
        key="moon"
        class="ram-theme-toggle__icon"
        viewBox="0 0 24 24"
        width="18"
        height="18"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </svg>
    </Transition>
  </button>
</template>

<script setup lang="ts">
import { useTheme } from "../composables/useTheme";

const { mode, toggle } = useTheme();
</script>

<style scoped>
.ram-theme-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: var(--ram-color-surface-raised);
  color: var(--ram-color-text-primary);
  border: 1px solid var(--ram-color-border);
  border-radius: var(--ram-radius-full);
  cursor: pointer;
  transition:
    transform var(--ram-duration-fast) var(--ram-ease-out),
    box-shadow var(--ram-duration-base) var(--ram-ease-out),
    border-color var(--ram-duration-base) var(--ram-ease-out);
}
.ram-theme-toggle:hover {
  border-color: var(--ram-color-action-500);
  box-shadow: var(--ram-glow-action);
  transform: translateY(-1px);
}
.ram-theme-toggle:active {
  transform: translateY(0);
}
.ram-theme-toggle__icon {
  display: block;
  color: var(--ram-color-action-600);
}
[data-theme="dark"] .ram-theme-toggle__icon {
  color: var(--ram-color-action-300);
}

.ram-theme-toggle__swap-enter-active,
.ram-theme-toggle__swap-leave-active {
  transition:
    opacity var(--ram-duration-fast) var(--ram-ease-out),
    transform var(--ram-duration-base) var(--ram-ease-out);
}
.ram-theme-toggle__swap-enter-from {
  opacity: 0;
  transform: rotate(-90deg) scale(0.6);
}
.ram-theme-toggle__swap-leave-to {
  opacity: 0;
  transform: rotate(90deg) scale(0.6);
}
</style>
